var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../../classes/common';
import { FaqQuestionDto } from '../../../../classes/faq/faq-question/response/faq-question.dto';
import { UserWithoutRelationsDto } from '../../../../classes/user/response/user-without-relations.dto';
export class FaqAnswerDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        Object.assign(this, initializer);
    }
}
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", UserWithoutRelationsDto)
], FaqAnswerDto.prototype, "createdBy", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Object)
], FaqAnswerDto.prototype, "updatedBy", void 0);
__decorate([
    Type(() => FaqQuestionDto),
    __metadata("design:type", Array)
], FaqAnswerDto.prototype, "questions", void 0);
